"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var pickup_locations_html_1 = __importDefault(require("./pickup-locations.html"));
var pickup_locations_controller_1 = __importDefault(require("./pickup-locations.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.pickuplocations", {
        url: "/pickuplocations",
        controller: pickup_locations_controller_1.default,
        controllerAs: "vm",
        template: pickup_locations_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.pickuplocations", [])
    .config(config)
    .controller("AdminStudentsPickupLocationsController", pickup_locations_controller_1.default);
